import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { rootReducer } from '@wellesley/store'

export const MIN_WIDTH_FOR_STICKY_SIDEBAR = 1280

export type ToolbarItemState = {
  activeItem: string | null
  previousActiveItem: string | null
  stickyItemId: string | null
  isSideBarCloseBlocked: boolean
}

const initialToolbarItemState: ToolbarItemState = {
  activeItem: null,
  previousActiveItem: null,
  stickyItemId: null,
  isSideBarCloseBlocked: false,
}

export const {
  actions: {
    setActiveItem,
    setActiveItemWithoutSideBar,
    toggleSideBarOpen,
    closeSideBar,
    openSideBar,
    setSideBarCloseBlocked,
  },
  selectors: {
    selectIsActive,
    selectIsSideBarSticky,
    selectStickyItemId,
    selectActiveItemId,
    selectSideBarCloseBlocked,
  },
} = createSlice({
  name: 'toolbarItem',
  initialState: initialToolbarItemState,
  reducers: {
    setSideBarCloseBlocked: (state, action: PayloadAction<boolean>) => {
      state.isSideBarCloseBlocked = action.payload
    },
    setActiveItem: (state, action: PayloadAction<string>) => {
      state.previousActiveItem = state.activeItem
      state.activeItem = action.payload
    },
    setActiveItemWithoutSideBar: (state, action: PayloadAction<string>) => {
      state.previousActiveItem = state.activeItem
      state.activeItem = action.payload
      state.stickyItemId = null
    },
    openSideBar: (state, action: PayloadAction<string | undefined>) => {
      state.stickyItemId = action.payload ?? state.activeItem ?? null
    },
    closeSideBar: (state) => {
      state.stickyItemId = null
    },
    toggleSideBarOpen: (state) => {
      const isSameActiveItem = state.previousActiveItem === state.activeItem
      const isCurrentlySticky = state.stickyItemId !== null
      const shouldOpen = isSameActiveItem ? !isCurrentlySticky : true
      state.stickyItemId = shouldOpen ? state.activeItem : null
    },
  },
  selectors: {
    selectIsActive: (state, id: string) => state.activeItem === id,
    selectActiveItemId: (state) => state.activeItem,
    selectIsSideBarSticky: (state) => state.stickyItemId !== null,
    selectStickyItemId: (state) => state.stickyItemId,
    selectSideBarCloseBlocked: (state) => state.isSideBarCloseBlocked,
  },
}).injectInto(rootReducer)
